import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router';

import { APP_TITLE, IS_PRODUCTION } from 'constants/Global';
import { isCustomBranding as isCustomBrandingSelector } from 'modules/users/selectors/currentUser';
import AppEnvironment from 'ui/layout/header/AppEnvironment';

import CustomLogos from './CustomLogos';
import FleetbackLogos from './FleetbackLogos';

import * as stylesHeader from './Header.module.less';

const AppTitle = () => {
  const isCustomBranding = useSelector(isCustomBrandingSelector);

  return (
    <Link className={stylesHeader.header__brand} to="/">
      {!IS_PRODUCTION && <AppEnvironment />}
      <span className={stylesHeader['header-logo']} aria-label={APP_TITLE}>
        {isCustomBranding ? <CustomLogos /> : <FleetbackLogos />}
      </span>
    </Link>
  );
};

export default AppTitle;
